module.exports = __webpack_public_path__ + "static/note-3-b6508a6a82e3674408949be0175db04b.jpg";